import { SearchCampaignItem } from 'modules/campaigns/types/SearchCampaigns';
import { Campaign } from 'services/campaign/types';

export const addChildrenCampaignsToParentGroupCampaign = ({
  childrenCampaigns,
  campaignGroupId,
  campaigns,
  isParentInOtherCampaigns
}: {
  childrenCampaigns: (Campaign | SearchCampaignItem)[];
  campaignGroupId: string;
  campaigns: (Campaign | SearchCampaignItem)[];
  isParentInOtherCampaigns: boolean | undefined;
}): (Campaign | SearchCampaignItem)[] => {
  const groupCampaignIndex = campaigns.findIndex(
    (campaign) => campaign?.campaignGroupId === campaignGroupId
  );

  if (groupCampaignIndex !== -1) {
    const updatedCampaigns = [...campaigns];

    const isChildrenInList = childrenCampaigns.some((child) =>
      updatedCampaigns.some((campaign) => campaign?.id === child?.id)
    );

    if (isChildrenInList) {
      return updatedCampaigns.map((campaign) =>
        campaign?.campaignGroupId === campaignGroupId
          ? {
              ...campaign,
              isHidden: false,
              isParentInOtherCampaigns
            }
          : campaign
      );
    }

    updatedCampaigns.splice(
      groupCampaignIndex + 1,
      0,
      ...childrenCampaigns.map((child) => ({
        ...child,
        isHidden: false,
        isParentInOtherCampaigns
      }))
    );

    return updatedCampaigns;
  }

  return campaigns;
};
